export default __webpack_public_path__ + "static/media/You caught me at a bad time .3f8a5ef7.mp4";